<template>
    <div class="poster">
        <div class="title">
            <p>经销商管理</p>
        </div>
        <div class="main">
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-input v-model="formInline.agencyId" placeholder="请输入编号ID" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.agencyName" placeholder="请输入经销商名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.principalsInfo" placeholder="请输入姓名/电话" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="formInline.status" placeholder="请选择分类" @change="statusChange">
                            <el-option label="全部" value="0"></el-option>
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="停权" value="2"></el-option>
                            <el-option label="取消" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main table">
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="全部" name="0"></el-tab-pane>
                    <el-tab-pane label="一级" name="1"></el-tab-pane>
                    <el-tab-pane label="二级" name="2"></el-tab-pane>
                    <el-tab-pane label="三级" name="3"></el-tab-pane>
                </el-tabs>
                <div class="btnlist">
                    <el-upload class="btn" action="" :on-change="handleChange" :show-file-list="false" accept=".xls,.xlsx" :auto-upload="false">
                        <el-button :loading="disbtn" size="medium" type="warning">导入表格</el-button>
                    </el-upload>
                    <el-button class="btn" type="success" size="medium" @click="getTMUrl">模板下载</el-button>
                    <el-button class="btn" type="primary" size="medium" @click="selectProduct('createAgency')">+ 添加经销商</el-button>
                </div>
            </div>
            <div class="table">
                <el-table ref="table" :data="tableData" style="width: 100%" v-loading="tabload">
                    <el-table-column prop="id" label="编号ID" align="center" width="80px"> </el-table-column>
                    <el-table-column prop="name" label="经销商名称" align="center" width="180px"> </el-table-column>
                    <el-table-column prop="principals_name" label="负责人名称" align="center" width="180px"> </el-table-column>
                    <el-table-column prop="principals_phone" label="负责人电话" align="center" width="180px"> </el-table-column>
                    <el-table-column prop="level" label="经销级别" align="center" width="180px">
                        <template slot-scope="scope">
                            {{ scope.row.level == 1 ? "一级" : scope.row.level == 2 ? "二级" : "三级" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="start_time" label="授权起止时间" align="center" width="260px">
                        <template slot-scope="scope">
                            <p :class="!CheckDateTime(AddDateFmt(0, scope.row.end_time)) ? 'red' : !CheckDateTime(AddDateFmt(-15, scope.row.end_time)) ? 'orange' : ''">
                                {{ scope.row.start_time }}~{{ scope.row.end_time
                                }}{{ !CheckDateTime(AddDateFmt(0, scope.row.end_time)) ? "（已过期）" : !CheckDateTime(AddDateFmt(-15, scope.row.end_time)) ? "（即将过期）" : "" }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" align="center" width="140px">
                        <template slot-scope="scope">
                            <span :class="scope.row.status == 2 ? 'red' : ''">
                                {{ scope.row.status == 1 ? "正常" : scope.row.status == 2 ? "停权" : "取消" }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center" fixed="right" width="240px">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link v-show="scope.row.status == 1 && scope.row.status != 3" type="primary" @click="operate(0, scope.row.id)">停权</el-link>
                                <el-link v-show="scope.row.status == 2 && scope.row.status != 3" type="primary" @click="operate(4, scope.row)">解除</el-link>
                                <el-link v-show="scope.row.status != 3 && scope.row.status != 2" type="primary" @click="selectProduct('editAgency', scope.row.id)">编辑</el-link>
                                <el-link type="primary" @click="selectProduct('detailAgency', scope.row.id)">详情</el-link>
                                <el-link v-show="scope.row.status == 1 && scope.row.status != 3" type="primary" @click="operate(1, scope.row.id), 'ancel'">取消</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <Detail ref="refDetail" @selectProduct="selectProduct"></Detail>
        <Operate ref="refOperate" :_type="optType" @init="getProductList" @initList="getList"></Operate>
        <CreateOrEdit ref="refCreateOrEdit" @init="getList(1)" @listId="listIdNull" :treeData="treeData" @selectProduct="selectProduct"></CreateOrEdit>
        <InstallProduct ref="refInstallProduct"></InstallProduct>
        <ServeProduct ref="refServeProduct"></ServeProduct>
        <CreateOrEditProduct ref="refCreateOrEditProduct" :brandNameList="brandNameList" :proTreeData="proTreeData" @init="getProductList" @bindProductId="bindProductId"></CreateOrEditProduct>
        <ProductMonitor
            ref="refProductMonitotr"
            @selectProduct="selectProduct"
            :GoodsClassifys="GoodsClassifys"
            :proTreeData="proTreeData"
            @moveList="operate"
            @selProductId="selProductId"
        ></ProductMonitor>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import CreateOrEdit from "@/components/Modules/MarketingManagement/CreateOrEdit.vue";
import Operate from "@/components/Modules/MarketingManagement/Operate.vue";
import Detail from "@/components/Modules/MarketingManagement/Detail.vue";
import CreateOrEditProduct from "@/components/Modules/MarketingManagement/CreateOrEditProduct.vue";
import ServeProduct from "@/components/Modules/MarketingManagement/ServeProduct.vue";
import InstallProduct from "@/components/Modules/MarketingManagement/InstallProduct.vue";
import ProductMonitor from "@/components/Modules/MarketingManagement/ProductMonitor.vue";
import config from "@/assets/config.json";
export default {
    components: {
        Operate,
        Detail,
        CreateOrEdit,
        ServeProduct,
        InstallProduct,
        ProductMonitor,
        CreateOrEditProduct,
    },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            selType: 1,
            tableData: [],
            formInline: {
                agencyId: "", //经销商id，非必填
                agencyName: "", //经销商名称，非必填
                principalsInfo: "", //负责人名字或电话，非必填
                status: "", //状态 1-正常 2-停权，非必填
            },
            activeName: "0",
            // 弹窗类型
            type: "",
            // 操作弹窗类型
            optType: 0,
            // 树状下拉选项
            treeData: [],
            proTreeData: [],
            GoodsClassifys: [],
            disbtn: false,
            // 品牌名称列表
            brandNameList: [],
            // 规格列表
            // specList: [],
            // 选择产品的id
            productIdList: [],
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getTree();
        this.getProTree();
        this.getGoodsClass();
        this.getList(1);
        this.getBrandNameFunc();
        // this.getSpecListFunc();
    },
    methods: {
        ...mapActions({
            getAgencyList: "brand/getAgencyList", //经销商列表
            getDeauthorizeTypeList: "brand/getDeauthorizeTypeList", //添加经销商授权分类
            getGoodsClassifys: "brand/getGoodsClassifys", //商品分类
            getTreeList: "brand/getTreeList", //产品类型
            upLoadTemplate: "brand/upLoadTemplate", //导入模板
            getTemplateUrl: "brand/getTemplateUrl", //下载模板
            getBrandName: "brand/getBrandName", //品牌名称列表
            // getSpecList: "brand/getSpecList", //规格列表
        }),
        CheckDateTime(str) {
            var timestamp1 = new Date(str).getTime();
            var timestamp2 = new Date().getTime();
            var d = timestamp1 - timestamp2; //d>0 没到时间  d<0时间已经过了
            return d > 0;
        },
        AddDateFmt(days, oldDate) {
            var nd = new Date(oldDate).getTime();
            //nd = nd.valueOf();
            nd = nd + days * 24 * 60 * 60 * 1000;
            nd = new Date(nd);
            var y = nd.getFullYear();
            var m = nd.getMonth() + 1;
            var d = nd.getDate();
            var h = nd.getHours();
            var min = nd.getMinutes();
            var s = nd.getSeconds();
            if (m <= 9) m = "0" + m;
            if (d <= 9) d = "0" + d;
            if (h <= 9) h = "0" + h;
            if (min <= 9) min = "0" + min;
            if (s <= 9) s = "0" + s;
            var cdate = `${y}-${m}-${d} ${h}:${min}:${s}`;
            return cdate;
        },
        // 关闭添加弹窗清除选择产品
        listIdNull() {
            this.productIdList = [];
            this.$refs.refCreateOrEdit.productIdList = [];
        },
        selProductId(arr) {
            this.productIdList = arr;
            this.$refs.refCreateOrEdit.productIdList = arr;
            this.$refs.refCreateOrEdit.productCount = arr.length;
        },
        // 操作
        operate(tag, data) {
            this.optType = tag;
            this.$refs.refOperate.info = data;
            this.$refs.refOperate.dialogVisible = true;
        },
        // 名单操作成功刷新产品列表
        getProductList(tag) {
            this.$refs.refProductMonitotr.getList(tag == 1 ? 1 : 0);
        },
        // 下载模板链接
        getTMUrl() {
            window.open(`${config.brandHttps.api}/merchant/agency/downloadtemplate?token=${this.getToken}&port=merchant`);
        },
        // 导入模板
        handleChange(file, fileList) {
            this.disbtn = true;
            var formdata = new FormData();
            formdata.append("file", file.raw);
            formdata.append("port", "merchant");
            formdata.append("token", this.getToken);
            this.upLoadTemplate(formdata).then(({ data }) => {
                this.disbtn = false;
                if (data.code == 1) {
                    this.$message.success("上传成功！");
                    this.getList(1);
                } else {
                    this.$message({
                        type: "error",
                        message: data.msg,
                    });
                }
            });
        },
        bindProductId(id) {
            this.$refs.refProductMonitotr.bindProductId(id);
        },
        // 规格列表
        getSpecListFunc() {
            let opt = {
                token: this.getToken,
            };
            this.getSpecList(opt).then(({ data }) => {
                // console.log(data);
                if (data.code == 1) {
                    this.specList = [];
                    data.data.list.forEach((item) => {
                        let obj = {
                            name: item.name,
                            value: "",
                        };
                        this.specList.push(obj);
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 品牌名称列表
        getBrandNameFunc() {
            let opt = {
                token: this.getToken,
            };
            this.getBrandName(opt).then(({ data }) => {
                // console.log(data);
                if (data.code == 1) {
                    this.brandNameList = data.data.list;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 商品分类
        getGoodsClass() {
            let opt = {
                token: this.getToken,
                classifys_type_id: 2000,
            };
            this.getGoodsClassifys(opt).then(({ data }) => {
                // console.log(data);
                if (data.code == 1) {
                    this.GoodsClassifys = data.data.treeData;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 产品分类
        getProTree() {
            let opt = {
                token: this.getToken,
                page: 0, //当前页数
                size: 0, //每页显示条数
            };
            this.getTreeList(opt).then(({ data }) => {
                if (data.code == 1) {
                    this.proTreeData = data.data.treeData;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 获取经销商分类
        getTree() {
            let opt = {
                token: this.getToken,
                port: "merchant",
            };
            this.getDeauthorizeTypeList(opt).then(({ data }) => {
                if (data.code == 1) {
                    this.treeData = this.arrFmt(data.data);
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 数组格式整理
        arrFmt(arr) {
            if (arr && arr.length > 0) {
                arr.forEach((item) => {
                    if (item.children.length > 0) {
                        this.arrFmt(item.children);
                    } else {
                        delete item.children;
                    }
                });
                return arr;
            }
        },
        // 安装-服务-产品
        selectProduct(type, id, agencyId) {
            if (type == "install") {
                this.$refs.refInstallProduct.bindData();
            } else if (type == "serve") {
                this.$refs.refServeProduct.bindData();
            } else if (type == "monitotr") {
                this.$refs.refProductMonitotr.bindData(id);
            } else if (type == "createProduct") {
                this.$refs.refCreateOrEditProduct.agencyId = agencyId;
                this.$refs.refCreateOrEditProduct.dialogVisible = true;
            } else if (type == "editProduct") {
                this.$refs.refCreateOrEditProduct.dialogVisible = true;
                this.$refs.refCreateOrEditProduct.editId = id;
                this.$refs.refCreateOrEditProduct.agencyId = agencyId;
                this.$refs.refCreateOrEditProduct.getDetail(id);
            } else if (type == "editAgency") {
                this.$refs.refCreateOrEdit.dialogVisible = true;
                this.$refs.refCreateOrEdit.getDetail(id);
            } else if (type == "detailAgency") {
                this.$refs.refDetail.dialogVisible = true;
                this.$refs.refDetail.getDetail(id);
            } else if (type == "createAgency") {
                this.$refs.refCreateOrEdit.dialogVisible = true;
            }
        },

        // 状态筛选
        statusChange() {
            this.getList(1);
        },
        // 经销商列表
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                port: "merchant", //必填，固定值
                agencyId: this.formInline.agencyId, //经销商id，非必填
                agencyName: this.formInline.agencyName, //经销商名称，非必填
                principalsInfo: this.formInline.principalsInfo, //负责人名字或电话，非必填
                status: this.formInline.status == 0 ? null : this.formInline.status, //状态 1-正常 2-停权，非必填
                level: this.activeName == 0 ? null : this.activeName, //经销商级别 1-一级 2-二级 3-三级 如果传0则获取全部，必填
                page_size: this.size, //页大小
                page: this.page, //页数
            };
            this.getAgencyList(opt).then(({ data }) => {
                // console.log(data);
                this.tabload = false;
                if (data.code == 1) {
                    this.tableData = data.data.data;
                    this.total = data.data.total ? data.data.total : 0;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 分页
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        // 分页
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        // 搜索
        onSubmit() {
            this.getList(1);
        },
        // 重置
        reset() {
            this.formInline = {
                agencyId: "", //经销商id，非必填
                agencyName: "", //经销商名称，非必填
                principalsInfo: "", //负责人名字或电话，非必填
                status: "", //状态 1-正常 2-停权，非必填
            };
            this.getList(1);
        },
        // 级别筛选
        handleClick() {
            this.$nextTick(() => {
                this.$refs.table.doLayout(); //解决表格错位
            });
            this.getList(1);
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px;
    }
    ::v-deep .el-tabs__active-bar {
        width: 120px;
    }

    ::v-deep .el-tabs__item {
        width: 120px;
        text-align: center;
        padding: 0;
    }

    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;

        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .main.table {
        min-width: 1200px;
        min-height: 600px;
        .table {
            min-height: 500px;
        }
    }
    .main {
        min-width: 1200px;
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
        .tabs {
            position: relative;
        }
        .btnlist {
            position: absolute;
            right: 0;
            bottom: 28px;
            display: flex;
            .btn {
                margin-left: 10px;
            }
        }
        span {
            margin-right: 10px;

            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }

        ::v-deep .el-table th {
            background: #fafafa;
            padding: 10px 0;
        }
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.link {
    a {
        margin: 0 12px;
    }
}
.red {
    color: red;
}
.orange {
    color: orange;
}
</style>